import * as Raven from "raven-js";
import 'whatwg-fetch';
var ErrorService = /** @class */ (function () {
    function ErrorService() {
        var _this = this;
        this.criticalError = function (e) {
            return _this.logError(e);
        };
        this.logError = function (e) {
            if (e) {
                console.error(e);
                Raven.captureException(e);
            }
        };
    }
    ErrorService.prototype.failOnErrorPromise = function (state, promise) {
        var _this = this;
        return promise.then(function () {
            state.success();
        }).catch(function (e) {
            state.failed();
            _this.criticalError(e);
        });
    };
    ;
    ErrorService.prototype.failOnError = function (state) {
        var _this = this;
        return function (e) {
            if (e) {
                state.failed();
                _this.criticalError(e);
            }
            else {
                state.success();
            }
        };
    };
    return ErrorService;
}());
export var errorServiceInstance = new ErrorService();
export default errorServiceInstance;



//////////////////
// WEBPACK FOOTER
// ./js/services/error.service.ts
// module id = EFCD
// module chunks = 1 2 3 4 5 6